module.exports = __webpack_public_path__ + "static/media/4.a8873ea0.png";